export default __webpack_public_path__ + "static/media/mx_advert.1f5fdbe8.png";